import React, { Component } from "react";
import { Button, Confirm, Form, Header, Message, Modal, Segment } from "semantic-ui-react";
import Flatpickr from "react-flatpickr";

import { AppContext } from "../../utils/context";
import request from "../../utils/request";

import AddPrize from "./EventAddPrize";

const dateTimePicker = {
  enableTime: true,
  dateFormat: "Y-m-d H:i"
};

class PickWinner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawId: 0,
      eventId: this.props.eventId,
      event: {
        id: 0,
        title: ""
      },
      finalDraw: 0,
      isLoading: true,
      prices: [],
      winningTicket: false,
      prizeOptions: [],
      prizes: [],
      devices: [],
      tickets: [],
      timeRangeStart: null,
      timeRangeEnd: null,
      isCtaJackpot: this.props.winners && this.props.winners[0] && this.props.winners[0].game_id === 3 ? 1 : 0,
      isSecondary: 0,
      warningMsg: null,
      selectedPrize: null,
      xhrResponse: {
        success: null,
        status: "",
        message: ""
      },
      drawDisabled: true,
      modal: false,
      void: false,
      final: false,
      confirmShopify: false
    };
  }
  componentDidMount = () => {
    this.init();
  };
  componentDidUpdate = prevProps => {
    if (this.props.event !== prevProps.event) {
      this.setState({ event: this.props.event }, this.init);
    }
  };
  init = async () => {
    this.setState({ isLoading: true });
    let eventId = this.props.eventId;
    let event = await request.get(this, `api:/event/${eventId}`, { eventId: eventId });
    let winners = await request.get(this, `api:/event/${eventId}/winners`, { eventId: eventId, ts: Date.now() });
    let devices = await request.get(this, `api:/event/${eventId}/devices`, { eventId: eventId, ts: Date.now() });

    this.setPrizes(winners);
    this.setState({ event: event, devices: devices, isLoading: false });
  };
  handleChange = (e, { name, value }) => {
    if (name === 'prizes' && this.state.prizeOptions && value) {
      this.state.prizeOptions.map(opt => {
        if (opt.id === value) {
          this.setState({ selectedPrize: opt });
          if (opt.criteria) {
            this.setState({ timeRangeStart: opt.criteria.start });
            this.setState({ timeRangeEnd: opt.criteria.end });
          }
          let newXhrResponse = this.state.xhrResponse;
          if (opt.issecondary) {
            newXhrResponse.status = 'success';
            this.setState({ 
              isSecondary: 1, 
              isCtaJackpot: 0,
              xhrResponse: newXhrResponse,
              drawDisabled: false 
            });
          } else {
            this.setState({ isSecondary: 0 });
            if (opt.gameid === 3) {
              this.setState({ isCtaJackpot: 1 });
            }

            this.setPreCheck(opt);
          }
        }
      });
    }
    this.setState({ [name]: value });
  }
  handleToggle = (e, { name, value }) => this.setState({ [name]: this.state[name] === 1 ? 0 : 1 });
  handleReset = (resp) => {
    if (!resp.exception && !resp.errors && !(resp.status === 'error')) {
      this.setState({
        drawId: 0,
        winningTicket: false,
        prizes: [],
        modal: false
      }, this.props.close);
    }
  };
  setPrizes = resp => {
    let prizeList = [];
    let prizes = [];
    resp.data.map(value => {
      if (value.number === null) {
        prizeList.push({
          id: value.id,
          value: value.id,
          text: value.title,
          gameid: value.game_id,
          criteria: value.criteria,
          issecondary: value.is_secondary
        });
      }
      return value;
    });
    
    this.setState({ prizeOptions: prizeList, prizes: prizes });
  };
  setPreCheck = opt => {
    let hasActive = false;
    let newXhrResponse = this.state.xhrResponse;

    // Check if any devices still active if not secondary draw
    if (!opt.isSecondary) {
      for (var i in this.state.devices['data']) {
        let device = this.state.devices['data'][i];
        if ((device['unit_id'] !== 0 && device['unit_id'] !== '-' || device['can_deactivate'] == false) && device['confirm'] === 0) {
          hasActive = true;
        }
      }

      // if (this.state.event.shopify_enabled && this.state.event.pending_shopify_count > 0) {
      //   newXhrResponse.status = 'error';
      //   newXhrResponse.message = 'Please ensure all pending Shopify order have been processed before performing Jackpot draw.';
      //   this.setState({
      //     xhrResponse: newXhrResponse,
      //     drawDisabled: true,
      //     warningMsg: 'Please ensure all pending Shopify order have been processed before performing Jackpot draw.'
      //   });
      //   return;   
      // }

      if (hasActive) {
        newXhrResponse.status = 'error';
        newXhrResponse.message = 'Please ensure all devices are deactivated before performing Jackpot draw.';
        this.setState({
          xhrResponse: newXhrResponse,
          drawDisabled: true,
          warningMsg: 'Please ensure all devices are deactivated before performing Jackpot draw.'
        });
        return;
      }
    }

    newXhrResponse.status = 'success';
    this.setState({
      xhrResponse: newXhrResponse,
      drawDisabled: false,
      warningMsg: null
    });
    return;
  };
  handleWinner = () => {
    let payload = {
      number: this.state.winningTicket.number,
      draw_id: this.state.prizes
    };
    request.post(this, `api:/event/${this.state.event.id}/winners`, payload).then(resp => {
      this.setState({
        xhrResponse: resp,
      }, this.handleReset(resp));
    });
  };
  drawTickets = () => {
    if (this.state.disabled || this.state.drawDisabled) {
      return;
    }
    this.setState({ isLoading: true, disabled: true });
    return request.post(this, `api:/event/${this.state.eventId}/winners`, { draw_id: this.state.prizes, final_draw: this.state.finalDraw })
      .then(resp => {
        if (resp.exception || resp.errors || resp.status === 'error') {
          this.setState({ xhrResponse: resp, isLoading: false });
          return false;
        }
        this.setState({ xhrResponse: resp, winningTicket: resp.ticket, isLoading: false, disabled: false, drawDisabled: false }, this.pickWinnerCallBack);
      });
  };
  pickWinnerCallBack = () => {
    setTimeout(this.closeModal, 2000);
  }
  closeModal = () => {
    this.setState({
      drawId: 0,
      winningTicket: false,
      prizes: [],
      modal: false, 
      isSecondary: 0,
      disabled: false,
      xhrResponse: {
        success: null,
        status: "",
        message: ""
      }
    }, this.props.close);
  }
  openFinalDraw = () => this.setState({ final: true })
  closeFinalDraw = () => this.setState({ final: false })
  confirmFinalDraw = (e) => this.setState({ final: false }, this.handleToggle(e, { name: 'finalDraw', value: 1 }))
  openVoid = () => this.setState({ void: true })
  closeVoid = () => this.setState({ void: false })
  confirmVoid = () => { 
    if (this.props.event.shopify_enabled) {
      this.setState({ void: false, confirmShopify: true }); 
    } else {
      this.setState({ void: false, modal: true }, () => this.init()); 
    } 
  }
  closeShopifyModal = () => this.setState({ confirmShopify: false }); // close shopify sales confirm modal
  confirmShopifyModal = () => this.setState({ confirmShopify: false, modal: true }, () => this.init());
  render() {
    const {
      isLoading,
      finalDraw,
      event,
      prizeOptions,
      prizes,
      winningTicket,
      xhrResponse,
      isCtaJackpot,
      isSecondary
    } = this.state;
    const { summary } = this.props;
    const { backendType } = this.context.config;
    const { language, settings } = this.context;

    let disablePickWinnerBtn = false;
    let warningMsg = "";

    if (this.state.drawDisabled || winningTicket !== false || this.state.disabled || (prizes && prizes.length === 0)) {
      disablePickWinnerBtn = true;
    }
    if (summary && summary.sets && (summary.sets.net === 0)) {
      warningMsg = "No sales found for this event!";
      disablePickWinnerBtn = true;
    } else if (this.state.warningMsg) {
      warningMsg = this.state.warningMsg;
      disablePickWinnerBtn = true;
    }

    return (
      <div>
        <Confirm
          open={this.state.void}
          content='Please confirm that all devices are deactivated, and all voids/refunds have been processed, before selecting a Jackpot winner'
          confirmButton='Confirm'
          onCancel={this.closeVoid}
          onConfirm={this.confirmVoid}
        />
        <Confirm 
          open={this.state.confirmShopify} 
          content={() => (
            <Segment basic>
              <Header as="h3">Prior to proceeding with this draw have you confirmed the following?</Header>
              <p>1. All returned tickets have been voided.</p>
              <p>2. You have ensured that Shopify and dashboard online sales match.</p>
            </Segment>
          )}
          confirmButton='Confirm'
          onCancel={this.closeShopifyModal}
          onConfirm={this.confirmShopifyModal}
        />
        {+settings.hidden.allow_must_go_draw > 0 && <Confirm
          open={this.state.final}
          content={() => (
            <Segment basic>
              <h4>Are you sure you make this the final draw?</h4>
              <p>If a <strong>{language.en[`game_${event.game_id}_prize_title`]}</strong> has not yet been selected, a <strong>{language.en[`game_${event.game_id}_prize_title`]}</strong> winner will be selected immediately.</p>
              <p>If the <strong>{language.en[`game_${event.game_id}_prize_title`]}</strong> winner's chosen envelope does not contain the winning card,
                a <strong>{language.en[`game_${event.game_id}_final_draw`]}</strong> draw will be held, see rules provided for more details.</p>
              <p>The <strong>{language.en[`game_${event.game_id}_final_draw`]}</strong> may take a while and cannot be undone.</p>
            </Segment>
          )}
          confirmButton="Yes, I'm sure"
          onCancel={this.closeFinalDraw}
          onConfirm={this.confirmFinalDraw}
        />}
        {+settings.hidden.allow_must_go_draw === 0 && <Modal
          open={this.state.final}
          size={"mini"}
          content={() => (
            <Segment basic>
              <h4>Final Draws have been disabled</h4>
              <br />
              <p>If you require a final draw, please contact <a href="mailto:bumpadmin@sportech.net">Bump Admin</a></p>
              <br />
              <hr />
              <Button primary content="Okay" onClick={this.closeFinalDraw} floated="right" />
              <br /><br />
            </Segment>
          )}
          onConfirm={this.closeFinalDraw}
          onCancel={this.closeFinalDraw}
        />}
        {+settings.hidden.allow_secondary_draws === 1 && (
            <Modal
              trigger={<Button secondary>Add a Prize</Button>}
              content={<AddPrize eventId={this.props.eventId} />}
              closeIcon
              onClose={this.props.close}
            />
          )}
        <Modal
          trigger={<Button primary onClick={this.openVoid}>Pick a Winner</Button>}
          closeIcon
          open={this.state.modal}
          onClose={this.closeModal}
        >
          <Header icon='trophy' content='Pick a Winner' />
          <Modal.Content>
            <Form
              id="pickWinner"
              loading={isLoading}
              success={xhrResponse.success === true}
              error={xhrResponse.status === "error" && xhrResponse.success !== null}
            >
              <Header as="h2">Pick a winner</Header>
              <Message success content={xhrResponse.message} />
              <Message warning content={warningMsg} visible={warningMsg !== ""} />
              <Message error content={xhrResponse.message || warningMsg} />
              <Form.Select
                name="prizes"
                fluid
                label="Draw(s)"
                placeholder="Draw(s)"
                search
                options={prizeOptions}
                value={prizes}
                onChange={this.handleChange}
                disabled={this.state.disabled}
              />
              {+isCtaJackpot > 0 && <Form.Group>
                <Form.Checkbox
                  warning={"true"}
                  name={"finalDraw"}
                  label="This is the final draw. Tickets will be selected until the winning card is found, or all the purchased envelopes have been revealed."
                  value={1}
                  checked={finalDraw === 1}
                  onChange={finalDraw === 1 ? this.handleToggle : this.openFinalDraw}
                  disabled={this.state.disabled}
                />
              </Form.Group>}

              {+isSecondary > 0 && <Form.Group widths={2}>
                <label>Draw Criteria:</label>
                <Form.Field>
                  <label>Start:</label>
                  <Flatpickr
                    name="timeRangeStart"
                    value={this.state.timeRangeStart || ""}
                    placeholder="Start"
                    options={dateTimePicker}
                    onChange={(_, str, b) =>
                      this.handleChange(b.element, {
                        name: "timeRangeStart",
                        value: str
                      })
                    }
                    disabled
                  />
                </Form.Field>
                <Form.Field>
                  <label>End:</label>
                  <Flatpickr
                    name="timeRangeEnd"
                    value={this.state.timeRangeEnd || ""}
                    placeholder="End"
                    options={dateTimePicker}
                    onChange={(_, str, b) =>
                      this.handleChange(b.element, {
                        name: "timeRangeEnd",
                        value: str
                      })
                    }
                    disabled
                  />
                </Form.Field>
              </Form.Group>}
              <Form.Group widths="equal">
                <Form.Input
                  name="winningTicket"
                  fluid
                  size="large"
                  transparent
                  label="Winning Ticket"
                  placeholder="Winning Ticket"
                  value={winningTicket ? winningTicket.number : ""}
                  readOnly={backendType === "rng"}
                  onChange={this.handleChange}
                />
                {event && event.game_id === 3 && (
                  <Form.Field>
                    <label>Card</label>
                    {winningTicket &&
                      <Header style={{ marginTop: "0px" }}>
                        {winningTicket.card_suit === "D" ? (<span style={{ "color": "red" }}>&diams;</span>) : ""}
                        {winningTicket.card_suit === "H" ? (<span style={{ "color": "red" }}>&hearts;</span>) : ""}
                        {winningTicket.card_suit === "S" ? (<span>&spades;</span>) : ""}
                        {winningTicket.card_suit === "C" ? (<span>&clubs;</span>) : ""}
                        {" "}
                        {winningTicket.card_rank}
                        {winningTicket.card_suit === "D" ? (<span> of diamonds</span>) : ""}
                        {winningTicket.card_suit === "H" ? (<span> of hearts</span>) : ""}
                        {winningTicket.card_suit === "S" ? (<span> of spades</span>) : ""}
                        {winningTicket.card_suit === "C" ? (<span> of clubs</span>) : ""}
                        <Header.Subheader>found in Envelope #{winningTicket.envelope}</Header.Subheader>
                      </Header>
                    }
                  </Form.Field>
                )}
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            {backendType === "rng" ? (
              <Button primary icon="ticket" content="Select Random Ticket" onClick={this.drawTickets} disabled={disablePickWinnerBtn} />
            ) : (
              <Button primary icon="ticket" content="Save Winner" onClick={this.handleWinner} disabled={disablePickWinnerBtn} />
            )}
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
PickWinner.contextType = AppContext;

export default PickWinner;
